/**
 * Antwortmöglichkeiten von MC-Aufgaben.
 * Bindet die Inputs ng-model an das scope von v3sExercise über 'require' und Einbindung des Controllers
 * 
 * @class directive_v3sMcAnswer
 * @memberOf v3sWbtPlayerApp:exercise:choice
 */
angular.module('v3sWbtPlayerApp').directive('v3sMcAnswer', [ function () {
    return {
        restrict: 'E',
        require: '^v3sDocument',
        controller: 'v3sAnswerController',
        scope: {
            'id': '@'
        },
        transclude: true,
        template: '<label v3s-clickable><input type="checkbox" ng-model="answer" value="{{id}}" bs-checkbox></input></label>',
        link: function (scope, element, attrs, ctrl, transclude) {
            var docCtrl = ctrl;

            scope.getVar = docCtrl.getVar;
            if (!!scope.id) {
                docCtrl.addElement(element);
            }
            var answerElement = scope.answerElement;
            var isUserAnswer = answerElement.getUserAnswer();
            if (!!isUserAnswer) {
                scope.answer = true;
            }
            scope.$watch('answer', function () {
                if (typeof scope.answer !== 'undefined') {
                    answerElement.setUserAnswer(scope.answer);
                }
            });
            transclude(scope, function (clone, scope) { scope.transcludeFunction(clone, scope); });
            if (!element.hasClass('graphicAnswer')) {
                element.addClass('defaultAnswer');
            }
            function preventEventBehavior(evt) {
                evt.stopPropagation();
            }
            element.bind('touchstart', preventEventBehavior);
            element.bind('touchend', preventEventBehavior);
        }
    };
}]);
